import { TEAM_MEMBERS } from '../data/content';
import { Mail, ArrowUpRight } from 'lucide-react';

export default function TeamSection() {
  return (
    <section id="equipo" className="py-20 md:py-28 bg-[#f8f7f4] dark:bg-[#0b131e] text-slate-900 dark:text-white relative transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-left max-w-3xl space-y-3">
          <p className="text-xs font-bold text-cyan-700 dark:text-cyan-400 tracking-widest uppercase">EQUIPO DIRECTIVO</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 dark:text-white tracking-tight leading-tight">
            Quienes lideran ÉPICA
          </h2>
          <p className="text-sm sm:text-base text-slate-600 dark:text-slate-300 leading-relaxed">
            Una dirección con visión estratégica y experiencia comprobada en comunicación corporativa, gestión de medios y posicionamiento digital.
          </p>
        </div>

        {/* Directors Grid */}
        <div className="mt-12 grid md:grid-cols-2 gap-8 max-w-5xl">
          {TEAM_MEMBERS.map((member, index) => (
            <div
              key={member.id}
              className="rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden flex flex-col justify-between hover:shadow-xl transition-all duration-300 group"
            >
              <div>
                {/* Photo Frame */}
                <div className="relative aspect-[4/3] bg-slate-100 dark:bg-slate-950 overflow-hidden">
                  <img
                    src={member.imageUrl}
                    alt={`${member.name} - ${member.role}`}
                    referrerPolicy="no-referrer"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent" />
                  
                  {/* Direct Email Tag on Photo */}
                  {member.email && (
                    <div className="absolute top-4 right-4">
                      <a
                        href={`mailto:${member.email}`}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-950/80 backdrop-blur-md text-slate-200 hover:text-cyan-300 text-[11px] font-bold border border-slate-700/80 transition-colors shadow-lg"
                      >
                        <Mail className="w-3.5 h-3.5 text-cyan-400" />
                        <span>Contacto Directo</span>
                      </a>
                    </div>
                  )}
                </div>

                {/* Bio Details */}
                <div className="p-6 sm:p-8 space-y-3">
                  <div
                    className={`h-1.5 w-12 rounded-full ${
                      index === 0 ? 'bg-rose-500' : 'bg-cyan-500'
                    }`}
                  />
                  <div>
                    <h3 className="text-2xl font-black text-slate-900 dark:text-white">{member.name}</h3>
                    <p
                      className={`text-xs font-bold uppercase tracking-wider ${
                        index === 0 ? 'text-rose-600 dark:text-rose-400' : 'text-cyan-700 dark:text-cyan-400'
                      }`}
                    >
                      {member.role}
                    </p>
                  </div>

                  <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed pt-1">
                    {member.bio}
                  </p>

                  {/* Direct Email Box */}
                  {member.email && (
                    <div className="pt-2">
                      <a
                        href={`mailto:${member.email}`}
                        className="inline-flex items-center gap-2 p-2.5 rounded-xl bg-slate-50 dark:bg-slate-950/80 border border-slate-200 dark:border-slate-800 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:text-cyan-600 dark:hover:text-cyan-400 hover:border-cyan-500 transition-colors w-full"
                      >
                        <Mail className="w-4 h-4 text-cyan-600 dark:text-cyan-400 shrink-0" />
                        <span className="truncate">{member.email}</span>
                        <ArrowUpRight className="w-3.5 h-3.5 ml-auto text-slate-400" />
                      </a>
                    </div>
                  )}

                  {/* Specialties */}
                  <div className="pt-3 flex flex-wrap gap-1.5">
                    {member.specialty.map((spec, idx) => (
                      <span
                        key={idx}
                        className="px-2.5 py-1 rounded-md bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 text-[11px] font-semibold"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
